import { useNotificationContextValue } from '../context';

export const useNotification = () => {
  const { pushNotification } = useNotificationContextValue();
  return pushNotification;
};
